import { render, staticRenderFns } from "./LegalPage.vue?vue&type=template&id=7b77e27f&scoped=true"
import script from "./LegalPage.vue?vue&type=script&setup=true&lang=js"
export * from "./LegalPage.vue?vue&type=script&setup=true&lang=js"
import style0 from "./LegalPage.vue?vue&type=style&index=0&id=7b77e27f&prod&scoped=true&lang=css"
import style1 from "./LegalPage.vue?vue&type=style&index=1&id=7b77e27f&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../client/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b77e27f",
  null
  
)

export default component.exports